import {STATUSES} from "@/models/LicenseStatus";
import {
  LICENSE_STATUS_TYPE_ACTIVE,
  LICENSE_STATUS_TYPE_INACTIVE,
  LICENSE_STATUS_TYPE_PENDING,
  buildLicenseWorkflow,
  addWorkflowStatus,
  removeWorkflowStatus,
  resolveWorkflowDefaultStatusId,
  resolveWorkflowDefaultStatusCode
} from "@strenforcement/domain/licenseWorkflow";

export const TYPE_ACTIVE = LICENSE_STATUS_TYPE_ACTIVE;
export const TYPE_INACTIVE = LICENSE_STATUS_TYPE_INACTIVE;
export const TYPE_PENDING = LICENSE_STATUS_TYPE_PENDING;

export class LicenseWorkflow {

  constructor(city) {
    this.city = city;
    this.reset();
  }

  reset() {
    this.data = buildLicenseWorkflow({
      workflow: this.city._get('licenseWorkflow'),
      builtinStatuses: STATUSES,
      includeBuiltinStatusesDefault: true,
      defaultStatusCode: 'submitted'
    });
  }

  addStatus() {
    this.data.statuses = addWorkflowStatus(this.data.statuses, {
      type: TYPE_PENDING
    });
  }

  removeStatus(id) {
    this.data.statuses = removeWorkflowStatus(this.data.statuses, id);
  }

  getStatus(id) {
    return this.statuses.find(status => status.id === id);
  }

  get statuses() {
    return this.data.statuses;
  }

  get defaultStatusCode() {
    return resolveWorkflowDefaultStatusCode({
      defaultStatus: this.defaultStatus,
      statuses: this.statuses
    });
  }

  get defaultStatus() {
    return resolveWorkflowDefaultStatusId({
      defaultStatus: this.data.defaultStatus,
      statuses: this.statuses
    });
  }

  set defaultStatus(defaultStatusId) {
    this.data.defaultStatus = defaultStatusId;
  }

  async commit() {
    await this.city.updateLicenseWorkflow(this.serialize());
    this.reset();
  }

  serialize() {
    return {
      ...this.data,
    };
  }
}
